import $ from 'jquery';

export const init = () => {
	const $searchBoxInput = $('.js-search-box input');

	function onFocus(event) {
		if (event.target === document.activeElement) {
			event.target.parentElement.classList.add('has-focus');
		}
	}

	function onFocusOut(event) {
		event.target.parentElement.classList.remove('has-focus');
	}

	if ($searchBoxInput.length > 0) {
		$searchBoxInput.on('focus', onFocus);
		$searchBoxInput.on('focusout', onFocusOut);
	}
};
